[
  {
    "token": "$deprecated-example-token",
    "msg": "This is an example of a deprecated token. If this was a real case, this message would contain information about how to migrate off this token."
  }
]
